import React from 'react';

import {
  gridCell,
  gridCellFixed,
  gridContainer,
} from '#Client/components/Grid/Grid.css';
import {Letter} from '#Client/components/Letter/Letter';

type SolutionProps = {
  label: string;
  puzzle: Puzzle;
};
type Puzzle = {
  Id: string;
  Hints: Record<string, string>;
  Word1: string;
  Word2: string;
  Word3: string;
  Word4: string;
  Word5: string;
};
export const Solution = ({label, puzzle}: SolutionProps) => (
  <div>
    <h3>{label}</h3>
    <table className={gridContainer}>
      <tbody>
        {[
          puzzle.Word1,
          puzzle.Word2,
          puzzle.Word3,
          puzzle.Word4,
          puzzle.Word5,
        ].map((word: string, index: number) => {
          const letters = word.split('');
          return (
            <tr key={index}>
              {letters.map((letter: string, index2: number) => {
                const isFixed =
                  `${index}-${index2}` in puzzle.Hints ||
                  `${index2}-${index}` in puzzle.Hints;
                return (
                  <td
                    className={`${gridCell} ${isFixed ? gridCellFixed : ''}`}
                    key={index2}
                  >
                    <Letter letter={letter} />
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
);
